import React from "react";
import { Link, useLocation } from "react-router-dom";
import { FaTableList, FaCalendarDays, FaBookOpen } from "react-icons/fa6";

import styles from "./TabelaAluno.module.scss";

const TabelaAluno = ({ columns, data }) => {
    const location = useLocation();
    const pathParts = location.pathname.split("/");
    const entidade = pathParts[1];

    return (
        <table className={styles.tabela}>
            <thead>
                <tr>
                    {columns.map(column => (
                        <th key={column.key}>{column.header}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                        {columns.map(column => (
                            <td key={column.key}>
                                {column.key === "turma" ? (
                                    <div className={styles.turma}>
                                        <div>{row[column.key]}</div>
                                        <div className={styles.acoes}>
                                            <Link to={`/${entidade}/area-aluno/relatorio/${row.code}`} className={`${styles.botao} ${styles.botaoNotas}`}>
                                                <span>
                                                    {/* <Icon type="table" /> */}
                                                    <FaTableList />
                                                </span>
                                                <span className={styles.texto}>Notas</span>
                                            </Link>

                                            <Link to={`/${entidade}/area-aluno/calendario/${row.code}`} className={`${styles.botao} ${styles.botaoHorario}`}>
                                                <span>
                                                    {/* <FaTableList /> */}
                                                    <FaCalendarDays />
                                                </span>
                                                <span className={styles.texto}>Horário</span>
                                            </Link>

                                            <Link
                                                to={`/${entidade}/area-aluno/conteudos/${row.code}`}
                                                className={`${styles.botao} ${styles.botaoConteudos}`}
                                                onClick={() => localStorage.removeItem("codigo_curso")}
                                            >
                                                <span>
                                                    <FaBookOpen />
                                                </span>
                                                <span className={styles.texto}>CONTEÚDOS</span>
                                            </Link>
                                        </div>
                                    </div>
                                ) : (
                                    row[column.key]
                                )}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TabelaAluno;
